export default __webpack_public_path__ + "static/media/anounce_medium.6cadbdfa.mp3";